import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { storeReferralCode } from "@/lib/referral";

/**
 * Public landing for shareable referral links: aivyv.com/r/{code}.
 *
 * Stashes the code in localStorage, then routes onward:
 *   - already authenticated → /home (code is moot; they have an account)
 *   - otherwise             → /auth (signup will claim the stored code)
 *
 * No UI — purely a capture + redirect hop.
 */
export default function ReferralCapture() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) storeReferralCode(code);
    let active = true;
    supabase.auth.getSession().then(({ data }) => {
      if (!active) return;
      navigate(data.session ? "/home" : "/auth", { replace: true });
    });
    return () => { active = false; };
  }, [code, navigate]);

  return <div className="fixed inset-0" style={{ background: "#050810" }} />;
}
